<template>
  <div class="basic-layout">
    <div class="sticky-top">
      <Header />
      <top-menu />
    </div>
    <div>
      <child />
    </div>
  </div>
</template>

<script>
import Header from '~/components/Header'
import TopMenu from '~/components/common/TopMenu/TopMenu'

export default {
  name: 'BasicLayout',
  components: {
    Header,
    TopMenu
  },
  data () {
    return {
    }
  }
}
</script>
